import React, { useState } from "react";
import { FieldArray } from "formik";

import {
    Button,
    Chip,
    FormControl,
    InputLabel,
    Select,
    Input,
    TextField,
    MenuItem,
    FormHelperText,
    Grid,
    Paper,
    IconButton,
    InputAdornment,
    Tooltip,
    Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { dateEquators, integerEquators, StringEquators, alphabets } from "../../../store/constants/pages";
import { Autocomplete } from '@mui/material';
import { RULE_CRITERIA_DATE, RULE_CRITERIA_INT, RULE_CRITERIA_LONG, RULE_CRITERIA_STRING } from "../../../store/constants/contract";
import { PopoverLink } from '../../../common/popoverLink'

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    portlet: {
        'box-shadow': 'none',
    },
    formControl: {
        width: '85%',
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
    },
    autoComplete: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    button: {
        margin: theme.spacing(1)
    },
    paper: {
        marginTop: theme.spacing(2),
    },
    iconButton: {
        marginTop: theme.spacing(3),
    },
    clearButton: {
        marginTop: theme.spacing(3),
        marginLeft: '10px',
        color: 'rgba(0, 0, 0, 0.54)'
    },
}));

export default function RuleSelectionCriteriaFieldArray({
    values, handleBlur, handleChange, touched, errors, ruleCriteria, setFieldValue, disableCriteriaSelection=false, npiRoles, dischargeStatusCodes = []
}) {

    const classes = useStyles();

    function getHelperText(key, index) {
        if (touched.ruleSelectionCriteriaXref) {
            if (touched.ruleSelectionCriteriaXref[index]) {
                return touched.ruleSelectionCriteriaXref[index][key];
            }
            return false;
        }
        return false;
    }

    function getError(key, index) {
        if (errors.ruleSelectionCriteriaXref) {
            if (errors.ruleSelectionCriteriaXref[index]) {
                return errors.ruleSelectionCriteriaXref[index][key];
            }
            return false;
        }
        return false;
    }

    function handleCriteriaChangeHandler(index, criteriaObj) {
        setFieldValue(`ruleSelectionCriteriaXref.${index}.ruleSelectionCriteriaId`, criteriaObj);
        setFieldValue(`ruleSelectionCriteriaXref.${index}.type`, criteriaObj?.fieldType); // criteria Type i.e. INT, DATE, STRING
        setFieldValue(`ruleSelectionCriteriaXref.${index}.equator`, (criteriaObj?.id === 5 || criteriaObj?.id === 6) ? 'equals' : '');
        setFieldValue(`ruleSelectionCriteriaXref.${index}.value`, '');
        setFieldValue(`ruleSelectionCriteriaXref.${index}.startsAt`, '');
        setFieldValue(`ruleSelectionCriteriaXref.${index}.endsAt`, '');
    }

    function getEquators(fieldType) {
        switch (fieldType) {
            case RULE_CRITERIA_STRING:
                return StringEquators.equatorArr
            case RULE_CRITERIA_DATE:
                return dateEquators.equatorArr
            case RULE_CRITERIA_INT:
                return integerEquators.equatorArr
                case RULE_CRITERIA_LONG:
                    return integerEquators.equatorArr
            default:
                return StringEquators.equatorArr
        }
    }

    function handleClearFields() {
        setFieldValue(`ruleSelectionCriteriaXref`, [{
            ruleSelectionCriteriaId: null,
            equator: '',
            value: '',
            startsAt: '',
            endsAt: ''
        }]);
    }

    function hoverColumn(text) {
        return (
            <PopoverLink
                columnData={<i className={`fas fa-question-circle text-info`}></i>}
                hoverData={[
                    {
                        data: text
                    }
                ]}
            />
        );
    }

    return (
        (<FieldArray
                name="ruleSelectionCriteriaXref"
                render={({ remove, insert }) => (
                    <Grid container>
                        <Grid item xs={12}>
                            {values.ruleSelectionCriteriaXref.map((selectionCriteria, index) =>
                                <Grid container>
                                   {!disableCriteriaSelection && <Grid item xs={3}>
                                        <Autocomplete
                                        // disabled={disableCriteriaSelection}
                                            className={classes.autoComplete}
                                            value={selectionCriteria.ruleSelectionCriteriaId}
                                            disableClearable={false}
                                            onChange={(e, value) => { handleCriteriaChangeHandler(index, value) }}
                                            isOptionEqualToValue={(option, value) => option === value}
                                            //name={`ruleSelectionCriteriaXref.${index}.ruleSelectionCriteriaId`}
                                            options={ruleCriteria.filter(criteria =>
                                                criteria.id !== 6 || selectionCriteria.ruleSelectionCriteriaId?.id === 6 ||
                                                !values.ruleSelectionCriteriaXref.some(x => x.ruleSelectionCriteriaId?.id === 6)
                                            )}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    name={`ruleSelectionCriteriaXref.${index}.ruleSelectionCriteriaId`}
                                                    label="Criteria"
                                                    error={Boolean(getHelperText('ruleSelectionCriteriaId', index) && getError('ruleSelectionCriteriaId', index))}
                                                    helperText={getHelperText('ruleSelectionCriteriaId', index) && getError('ruleSelectionCriteriaId', index)}
                                                    margin="normal" />
                                            }
                                        />
                                    </Grid>}
                                    {selectionCriteria.ruleSelectionCriteriaId?.id !== 5 && <>
                                    <Grid item xs={disableCriteriaSelection ?4  :3}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel htmlFor={`ruleSelectionCriteriaXref.${index}.equator`}>Equator</InputLabel>
                                            <Select
                                                required
                                                value={selectionCriteria?.equator}
                                                onChange={handleChange}
                                                disabled={!selectionCriteria?.ruleSelectionCriteriaId}
                                                input={<Input id={`ruleSelectionCriteriaXref.${index}.equator`} />}
                                                inputProps={{
                                                    name: `ruleSelectionCriteriaXref.${index}.equator`,
                                                    id: `ruleSelectionCriteriaXref.${index}.equator`,
                                                }}
                                                error={Boolean(getHelperText('equator', index) && getError('equator', index))}
                                            >
                                                {(selectionCriteria.ruleSelectionCriteriaId?.id === 6
                                                    ? [{ value: 'equals', label: 'Equal To' }, { value: 'not_equal_to', label: 'Not Equal To' }]
                                                    : getEquators(selectionCriteria?.type)
                                                ).map(equator => (
                                                    <MenuItem
                                                        key={equator.value}
                                                        value={equator.value}
                                                    >
                                                        {equator.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText error>{getHelperText('equator', index) && getError('equator', index)}</FormHelperText>

                                        </FormControl>
                                    </Grid>
                                    {selectionCriteria.ruleSelectionCriteriaId?.id !== 6 && <Grid item xs={disableCriteriaSelection ?4  :3}>
                                        {selectionCriteria?.equator === 'alpha_between' || selectionCriteria?.equator === 'in_between' ?
                                            <Grid container spacing={1}>
                                                {selectionCriteria?.type === RULE_CRITERIA_INT || selectionCriteria?.type === RULE_CRITERIA_LONG ?
                                                    <>
                                                        <Grid item xs={6}>
                                                            <TextField
                                                                type='number'
                                                                name={`ruleSelectionCriteriaXref.${index}.startsAt`}
                                                                className={classes.textField}
                                                                label="Starts at"
                                                                margin="normal"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={selectionCriteria.startsAt}
                                                                helperText={getHelperText('startsAt', index) && getError('startsAt', index)}
                                                                error={Boolean(getHelperText('startsAt', index) && getError('startsAt', index))}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <TextField
                                                                type='number'
                                                                name={`ruleSelectionCriteriaXref.${index}.endsAt`}
                                                                className={classes.textField}
                                                                label="Ends at"
                                                                margin="normal"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={selectionCriteria.endsAt}
                                                                error={Boolean(getHelperText('endsAt', index) && getError('endsAt', index))}
                                                                helperText={getHelperText('endsAt', index) && getError('endsAt', index)}
                                                            />
                                                        </Grid>
                                                    </>
                                                    : selectionCriteria?.type === RULE_CRITERIA_DATE ?
                                                        <>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    type='date'
                                                                    name={`ruleSelectionCriteriaXref.${index}.startsAt`}
                                                                    className={classes.textField}
                                                                    label="Starts at"
                                                                    margin="normal"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={selectionCriteria.startsAt}
                                                                    helperText={getHelperText('startsAt', index) && getError('startsAt', index)}
                                                                    error={Boolean(getHelperText('startsAt', index) && getError('startsAt', index))}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    type='date'
                                                                    name={`ruleSelectionCriteriaXref.${index}.endsAt`}
                                                                    className={classes.textField}
                                                                    label="Ends at"
                                                                    margin="normal"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={selectionCriteria.endsAt}
                                                                    helperText={getHelperText('endsAt', index) && getError('endsAt', index)}
                                                                    error={Boolean(getHelperText('endsAt', index) && getError('endsAt', index))}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </> :
                                                        <>
                                                            <Grid item xs={6}>
                                                                <FormControl className={classes.formControl}>
                                                                    <InputLabel htmlFor="startsAt">Starts At</InputLabel>
                                                                    <Select
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={selectionCriteria.startsAt}
                                                                        error={Boolean(getHelperText('startsAt', index) && getError('startsAt', index))}
                                                                        inputProps={{
                                                                            name: `ruleSelectionCriteriaXref.${index}.startsAt`,
                                                                            id: "startsAt"
                                                                        }}
                                                                    >
                                                                        {alphabets.map((item, alphaIndex) => (
                                                                            <MenuItem
                                                                                key={`${alphaIndex}-${item}`}
                                                                                value={item.toLowerCase()}
                                                                            >
                                                                                {item}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                    <FormHelperText error>{getHelperText('startsAt', index) && getError('startsAt', index)}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <FormControl className={classes.formControl}>
                                                                    <InputLabel htmlFor="endsAt">Ends At</InputLabel>
                                                                    <Select
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={selectionCriteria.endsAt}
                                                                        error={Boolean(getHelperText('endsAt', index) && getError('endsAt', index))}
                                                                        inputProps={{
                                                                            name: `ruleSelectionCriteriaXref.${index}.endsAt`,
                                                                            id: "endsAt"
                                                                        }}
                                                                    >
                                                                        {alphabets.map((item, alphaIndex) => (
                                                                            <MenuItem
                                                                                key={`${alphaIndex}-${item}`}
                                                                                value={item.toLowerCase()}
                                                                            >
                                                                                {item}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                    <FormHelperText error>{getHelperText('endsAt', index) && getError('endsAt', index)}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>
                                                        </>
                                                }
                                            </Grid>
                                            :
                                            <TextField
                                                label="Value"
                                                name={`ruleSelectionCriteriaXref.${index}.value`}
                                                className={classes.textField}
                                                margin="normal"
                                                disabled={selectionCriteria?.equator === ''}
                                                type={selectionCriteria?.type === RULE_CRITERIA_INT ? 'number' : selectionCriteria.type === RULE_CRITERIA_DATE ? 'date' : 'text'}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={selectionCriteria?.value}
                                                InputLabelProps={selectionCriteria.type === RULE_CRITERIA_DATE ?
                                                    {
                                                        shrink: true,
                                                    } : {

                                                    }
                                                }
                                                helperText={getHelperText('value', index) && getError('value', index)}
                                                error={Boolean(getHelperText('value', index) && getError('value', index))}

                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">
                                                        <span style={{pointerEvents: 'auto'}}>
                                                            {hoverColumn(selectionCriteria?.type === RULE_CRITERIA_INT ?
                                                                'Only single numeric value is allowed' :
                                                                'Add single string value or use comma separation for multiple values'
                                                            )}
                                                        </span>
                                                    </InputAdornment>
                                                }}
                                            />
                                        }
                                    </Grid>}
                                    </>
                                    }
                                    {selectionCriteria.ruleSelectionCriteriaId?.id === 5 &&
                                    <Grid item xs={disableCriteriaSelection ?4  :3}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel htmlFor="role">Select Provider Role</InputLabel>
                                            <Select
                                                required
                                                value={selectionCriteria?.value}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name={`ruleSelectionCriteriaXref.${index}.value`}
                                                disabled={!selectionCriteria?.ruleSelectionCriteriaId}
                                                input={<Input id={`ruleSelectionCriteriaXref.${index}.value`} />}
                                                inputProps={{
                                                    name: `ruleSelectionCriteriaXref.${index}.value`,
                                                    id: `ruleSelectionCriteriaXref.${index}.value`,
                                                }}
                                                error={Boolean(getHelperText('value', index) && getError('value', index))}
                                            >
                                                {npiRoles?.map(role => (
                                                    <MenuItem
                                                        key={role.id}
                                                        value={role.id}
                                                    >
                                                        {role.name}
                                                    </MenuItem>
                                                ))}

                                            </Select>

                                            <FormHelperText error>{getError('value', index)}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    }
                                    {selectionCriteria.ruleSelectionCriteriaId?.id === 6 &&
                                    <Grid item xs={3}>
                                        <Autocomplete
                                            multiple
                                            className={classes.autoComplete}
                                            options={dischargeStatusCodes}
                                            getOptionLabel={(option) => `${option.code} - ${option.description}`}
                                            value={dischargeStatusCodes.filter(item =>
                                                selectionCriteria?.value?.split(',').map(v => v.trim()).includes(item.code)
                                            )}
                                            onChange={(e, value) => {
                                                setFieldValue(
                                                    `ruleSelectionCriteriaXref.${index}.value`,
                                                    value.map(v => v.code).join(',')
                                                );
                                            }}
                                            isOptionEqualToValue={(option, value) => option.code === value.code}
                                            renderTags={(tagValue, getTagProps) => (
                                                    <Typography variant="caption" sx={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
                                                        {tagValue.map((option, idx) => (
                                                            <Tooltip key={idx} title={option?.description || ''}>
                                                                <Chip
                                                                    size="small"
                                                                    color="secondary"
                                                                    label={option?.code}
                                                                    sx={{ height: 20 }}
                                                                    {...getTagProps({ index: idx })}
                                                                />
                                                            </Tooltip>
                                                        ))}
                                                    </Typography>
                                            )}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    label="Discharge Status"
                                                    margin="normal"
                                                    error={Boolean(getHelperText('value', index) && getError('value', index))}
                                                    helperText={getHelperText('value', index) && getError('value', index)}
                                                />
                                            }
                                        />
                                    </Grid>
                                    }

                                    <Grid item xs={3}>
                                        <Grid container>
                                        {(index >= 0 && values.ruleSelectionCriteriaXref.length > 1) && (
                                            <IconButton
                                                edge="start"
                                                aria-label="Delete"
                                                onClick={() => remove(index)}
                                                className={classes.iconButton}
                                                size="large">
                                                <DeleteIcon />
                                            </IconButton>
                                        )}
                                        {index === 0 && (
                                            <>
                                            {!disableCriteriaSelection &&  <IconButton
                                                edge="start"
                                                color="primary"
                                                aria-label="Add"
                                                onClick={() => insert(values.ruleSelectionCriteriaXref.length, {
                                                    ruleSelectionCriteriaId: null,
                                                    equator: '',
                                                    value: '',
                                                    startsAt: '',
                                                    endsAt: ''
                                                })}
                                                className={classes.iconButton}
                                                size="large">
                                                <AddCircleIcon />
                                            </IconButton>}
                                            {/* <Button
                                                size="small"
                                                onClick={handleClearFields}
                                                className={classes.clearButton}
                                                startIcon={<DeleteIcon />}
                                            >
                                                Clear All
                                            </Button> */}
                                            </>
                                        )}
                                        </Grid>
                                    </Grid>
                                    
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
            />)
    );
}
